import type { QueryClient } from '@tanstack/react-query';

import { carePatientsKeys } from '@/entities/care-patients';

import type { DemoRoster } from '../api/demoRoster.js';
import { sandboxDemoKeys } from './keys.js';
import { hasSlotFinishedSeeding } from './roster.js';

/**
 * Refetches the patient list when `next` shows ready a copy that the cached
 * roster still shows seeding. Every path that puts a roster in the cache has to
 * call this: the poll's fetch, and the ensure and reseed responses. Whichever
 * one lands the ready roster first is the only one that sees the change.
 */
export function refreshPatientsIfSeedingFinished(queryClient: QueryClient, next: DemoRoster): void {
  const previous = queryClient.getQueryData<DemoRoster>(sandboxDemoKeys.roster);
  if (hasSlotFinishedSeeding(previous, next)) {
    void queryClient.invalidateQueries({ queryKey: carePatientsKeys.all });
  }
}

export function writeDemoRoster(queryClient: QueryClient, roster: DemoRoster): void {
  refreshPatientsIfSeedingFinished(queryClient, roster);
  queryClient.setQueryData(sandboxDemoKeys.roster, roster);
}
